module.exports = __webpack_public_path__ + "ejicons.9ded19ecaa9464d786ef.woff";


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/fc0fc15e/0/notifi/notifi-web-site/~/syncfusion-javascript/Content/ej/web/material/icons/ejicons.woff
// module id = ../../../../syncfusion-javascript/Content/ej/web/material/icons/ejicons.woff
// module chunks = 2